import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { IGetPatientAdherenceDataResponse } from "../../@types/Treatments";
import { treatmentsService } from "../../services/treatmentsService";
import { mixpanelActions } from "../../utils/mixpanel";
import { AdherenceGraphContainer } from "./components/AdherenceGraphContainer";
import { DashboardContainer } from "./Dashboard.styles";

export function Dashboard() {
  const { t } = useTranslation();

  document.title = t("dashboard_documentTitle");

  const [isLoading, setIsLoading] = useState(false);
  const [adherence, setAdherence] = useState<
    IGetPatientAdherenceDataResponse[]
  >([]);

  const handleGraphDisplay = () => {
    const graphsToAdd: JSX.Element[] = [];

    adherence?.forEach((data) => {
      graphsToAdd.push(
        <AdherenceGraphContainer
          key={data.protocolId}
          data={data}
          isLoading={isLoading}
        />
      );
    });

    return graphsToAdd;
  };

  useEffect(() => {
    const loadAdherence = async () => {
      setIsLoading(true);

      const adherenceData = await treatmentsService.getPatientsAdherenceData(
        new Date().toISOString()
      );

      setIsLoading(false);

      setAdherence(adherenceData);
    };

    mixpanelActions.track("Visited Screen: Dashboard");

    loadAdherence();
  }, []);

  return <DashboardContainer>{handleGraphDisplay()}</DashboardContainer>;
}
